exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full[data-v-db3ad9a0] {\n  width: 100%;\n}", ""]);

// exports
